"use client";

// import CountryFlag from "@/components/common/CountryFlag"; // chỉ dùng cho block "Điểm đến phổ biến" đang tắt
import FormSearchEsim from "@/components/esim/FormSearch";
import EsimHubHighlights from "@/components/esim/EsimHubHighlights";
import EsimHubTabs from "@/components/esim/EsimHubTabs";
import Esim from "@/components/esim/EsimPage";
import Title from "@/components/common/Typography/Title";
import Text from "@/components/common/Typography/Text";
// import Link from "@/components/common/Typography/Link"; // chỉ dùng cho link "Thông tin & hướng dẫn eSIM", giờ nhúng thẳng nội dung xuống dưới
// import { useTERouter } from "@/hooks/app/useTERouter"; // chỉ dùng cho goToCountry, đang tắt cùng block "Điểm đến phổ biến"
// import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"; // chỉ dùng để gọi /esim/countries, tạm tắt
// import { thunks } from "@/lib/redux/thunks"; // tạm tắt /esim/countries, dự tính thay bằng thư viện mã quốc gia
// import { EsimCountry } from "@/lib/redux/features/esim/types"; // chỉ dùng cho block "Điểm đến phổ biến" đang tắt
// import { buildEsimSearchBody } from "@/utils/esim/buildEsimSearchBody"; // chỉ dùng để gọi /esim/countries, tạm tắt
import { Card } from "antd";
// import { Row, Col } from "antd"; // chỉ dùng trong block "Điểm đến phổ biến"/link cũ đang tắt
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

type EsimHubPageClientProps = {
  /** Server component slot: campaign banners (GET /campaign). */
  bannersSlot?: ReactNode;
};

const EsimHubPageClient: FC<EsimHubPageClientProps> = ({ bannersSlot }) => {
  const { t } = useTranslation();
  // Tạm tắt /esim/countries + block "Điểm đến phổ biến" — dự tính thay bằng thư viện mã quốc gia.
  // const router = useTERouter();
  // const dispatch = useAppDispatch();
  // const extra = useAppSelector((state) => state.esim.esim_countries.data.extra);
  // const countries = useAppSelector((state) => state.esim.esim_countries.data.countries);

  // useEffect(() => {
  //   if (countries.length) return;
  //   dispatch(
  //     thunks.esim_countries({
  //       body: {
  //         TYPE: "JSON",
  //         ...buildEsimSearchBody(),
  //       },
  //     }),
  //   );
  // }, [countries.length, dispatch]);

  // const popularCountries = useMemo(() => {
  //   const popular = extra?.popular_countries ?? [];
  //   if (popular.length) return popular;
  //   return countries.slice(0, 12);
  // }, [countries, extra?.popular_countries]);

  // const goToCountry = (country: EsimCountry) => {
  //   router.push(`/esim-du-lich/quoc-gia/${country.code.toLowerCase()}`);
  // };

  return (
    <>
      <div className="esim-hub__hero-band">
        <div className="esim-hub__hero-content">
          <div className="esim-hub__hero-copy">
            <Title level={1} className="esim-hub__title">
              {t("esim.hub_title")}
            </Title>
            <Text className="esim-hub__subtitle">{t("esim.hub_subtitle")}</Text>
          </div>

          <Card className="esim-hub__search-card">
            <FormSearchEsim />
          </Card>

          <EsimHubHighlights />
        </div>
      </div>

      <div className="esim-catalog esim-hub">
        <div className="esim-catalog__content">
          {bannersSlot ? <section className="esim-hub__banners">{bannersSlot}</section> : null}

          <EsimHubTabs />

          {/* Tạm tắt block "Điểm đến phổ biến" cũ cùng /esim/countries — nội dung "Danh mục eSIM nổi
              bật"/"Khám phá thế giới"/content CMS đã dời vào tab "Chung" của EsimHubTabs ở trên.
          {popularCountries.length > 0 && (
            <section className="esim-hub__popular" aria-labelledby="esim-popular-heading">
              <Title id="esim-popular-heading" level={3} style={{ marginTop: 0 }}>
                {t("esim.popular_destinations")}
              </Title>
              <Row gutter={[12, 12]}>
                {popularCountries.map((country) => (
                  <Col xs={12} sm={8} md={6} key={country.code}>
                    <Button
                      type="default"
                      block
                      className="esim-hub__country-btn"
                      onClick={() => goToCountry(country)}
                    >
                      <div className="esim-hub__country-body">
                        <Row align="middle" gutter={6} wrap={false} style={{ marginBottom: 4 }}>
                          <Col flex="none">
                            <CountryFlag code={country.code} size={20} />
                          </Col>
                          <Col flex="auto" style={{ minWidth: 0 }}>
                            <div className="esim-hub__country-name">{country.countryName}</div>
                          </Col>
                        </Row>
                        <Text type="secondary" className="esim-hub__country-meta">
                          {country.continent}
                        </Text>
                      </div>
                    </Button>
                  </Col>
                ))}
              </Row>
            </section>
          )}
          */}

          {/* Trước là link sang /esim-du-lich/thong-tin — giờ nhúng thẳng nội dung xuống đây, không điều
              hướng nữa. Route cũ vẫn giữ nguyên (không xoá), phòng khi có link ngoài/SEO trỏ tới.
          <Row justify="center" style={{ marginTop: "2rem" }}>
            <Col>
              <Link href="/esim-du-lich/thong-tin">{t("esim.hub_info_link")}</Link>
            </Col>
          </Row>
          */}
        </div>
      </div>

      <Esim />
    </>
  );
};

export default EsimHubPageClient;
